export default function Logo({ size = 48, className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="Soft Landing ASMR"
      width={size}
      height={size}
      className={`select-none ${className}`}
      style={{ objectFit: "contain" }}
      data-testid="app-logo"
    />
  );
}
